import { Link } from 'react-router-dom';

const LandingFooter = () => {
  return (
    <footer className="border-t py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-center md:text-left">
            <span className="text-lg font-bold">Wololo Solutions</span>
            <p className="text-sm text-muted-foreground mt-1">
              Simple workforce management for modern teams.
            </p>
          </div>
          
          <nav className="flex flex-wrap justify-center gap-6 text-sm text-muted-foreground">
            <Link to="/auth?tab=signin" className="hover:text-foreground transition-colors">
              Sign In
            </Link>
            <Link to="/auth?tab=signup" className="hover:text-foreground transition-colors">
              Sign Up
            </Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">
              Terms
            </Link>
            <Link to="/dpa" className="hover:text-foreground transition-colors">
              Data Processing Addendum
            </Link>
          </nav>
        </div>
        
        <div className="text-center text-sm text-muted-foreground mt-8">
          © {new Date().getFullYear()} Wololo Solutions. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
